"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMobileOperatingSystem = getMobileOperatingSystem;
exports.isAndroid = isAndroid;
exports.isIos = isIos;
/**
 * Detect mobile operating system from user agent string
 *
 * This function returns one of 'ios', 'android' or null
 *
 * @param {string} ua user agent
 * @returns {string|null}
 */

function getMobileOperatingSystem(ua) {
  if (/android/i.test(ua)) {
    return 'android';
  } // iOS detection from: http://stackoverflow.com/a/9039885/177710


  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return 'ios';
  }

  return null;
}
/**
 * Is it Android?
 *
 * @param {string} ua user agent
 * @returns {boolean}
 */


function isAndroid(ua) {
  return getMobileOperatingSystem(ua) === 'android';
}
/**
 * Is it iOS?
 *
 * @param {string} ua user agent
 * @return {boolean}
 */


function isIos(ua) {
  return getMobileOperatingSystem(ua) === 'ios';
}